import React from "react";

import cx from "classnames";

import styles from "./Input.module.css";

interface InputCustomProps {
	innerRef?: React.Ref<HTMLInputElement>;
	isInvalid?: boolean;
}

type InputProps = React.HTMLProps<HTMLInputElement> &
	React.InputHTMLAttributes<HTMLInputElement> &
	InputCustomProps & {
		/**
		 * Names are used to define in the DOM what information this input requires.
		 * It's immensely helpful to Reflect for identifing elements during tests.
		 */
		name: string;
	};

export default class Input extends React.Component<InputProps, InputCustomProps> {
	constructor(props: InputProps) {
		super(props);
	}

	render() {
		const { className, innerRef, isInvalid, ...rest } = this.props;
		return <input {...rest} className={cx(styles.input, { [styles.invalid]: isInvalid }, className)} ref={innerRef} />;
	}
}

type SimpleInputProps = InputProps &
	InputCustomProps & {
		onValueChange: (val: string) => void;
	};

export function SimpleInput(props: SimpleInputProps) {
	const { onValueChange, className, innerRef, isInvalid, ...rest } = props;

	const onChange = React.useCallback(
		(e: React.FormEvent<HTMLInputElement>) => {
			onValueChange(e.currentTarget.value);
		},
		[onValueChange],
	);

	return (
		<input
			{...rest}
			className={cx(styles.input, styles.simpleInput, { [styles.invalid]: isInvalid }, className)}
			ref={innerRef}
			onChange={onChange}
		/>
	);
}

type IconInputProps = InputProps & { icon: React.ReactNode; onValueChange: (val: string) => void };

export function IconInput(props: IconInputProps) {
	const { className, innerRef, onValueChange, icon, ...rest } = props;

	const onChange = React.useCallback(
		(e: React.FormEvent<HTMLInputElement>) => {
			onValueChange(e.currentTarget.value);
		},
		[onValueChange],
	);

	return (
		<div className={cx(styles.inputRow, className)}>
			<div className={styles.iconWrapper}>
				<div className={styles.icon}>{icon}</div>
			</div>
			<input {...rest} className={cx(styles.input, styles.inputWithIcon)} ref={innerRef} onChange={onChange} />
		</div>
	);
}
